let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kjrCT")).then(() => parcelRequire('401YU'));